export const finallyBorder = (selectValue) => (selectValue ? '1px solid #EDEDED' : '1px solid #D00000');

export const finallyBorderInput = (selectValue) => (selectValue ? '1px solid #EDEDED' : '1px solid #D00000');
